module.exports = __webpack_public_path__ + "mo.e288e1ac625b310d8066.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/mo.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/mo.svg
// module chunks = styles